import { render, staticRenderFns } from "./SublimiteView.vue?vue&type=template&id=10f113ea&"
import script from "./SublimiteView.vue?vue&type=script&lang=js&"
export * from "./SublimiteView.vue?vue&type=script&lang=js&"
import style0 from "./SublimiteView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports